import React from 'react';
import { ModalContent } from '../../Components/manage-tags/ModalContent';
import { FormInput, FormLabelContainer } from '../../StyledComponents/Form';
import { TagKnown } from './TagsTable';
import Modal from 'react-modal';
import { useMutation } from '@tanstack/react-query';
import { deleteTag } from '../../services/TagsService';

interface DeleteTagModalProps {
  tag: TagKnown;
  isVisible: boolean;
  onClose: () => void | Promise<void>;
  refetch: () => void;
}

export const DeleteTagModal = (props: DeleteTagModalProps) => {
  const { tag, isVisible, onClose, refetch } = props;
  const { mutate, isPending: loading } = useMutation({
    mutationFn: deleteTag,
  });

  const handleClose = () => {
    onClose();
    refetch();
  };
  const handleDeleteTag = async () => {
    try {
      if (!tag.tagId) {
        throw new Error('Missing tag ID');
      }

      mutate(tag.tagId);
      refetch();
      handleClose();
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <Modal
      isOpen={isVisible}
      onRequestClose={handleClose}
      aria-labelledby="delete-tag-modal"
      aria-describedby="delete-tag-modal-description"
      style={{
        content: {
          paddingTop: 30,
          paddingBottom: 30,
          paddingLeft: 20,
          paddingRight: 20,
          display: 'flex',
          flexDirection: 'column',
          borderRadius: 8,
          minWidth: '26vw',
          position: undefined,
        },
        overlay: {
          backgroundColor: 'rgba(0,0,0,0.5)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 999,
        },
      }}
      ariaHideApp={false}
    >
      <ModalContent
        title={'Delete Tag'}
        loading={loading}
        handleSubmit={handleDeleteTag}
        submitDisabled={loading}
        handleClose={handleClose}
        buttonLabels={{ loading: 'Deleting Tag...', create: 'Delete' }}
      >
        <FormLabelContainer>
          <FormInput
            placeholder="Enter a tag name"
            maxLength={120}
            value={tag.tagName ?? 'Missing Tag Name'}
            autoCapitalize="none"
            onChange={(): void => {}}
            disabled
          />
        </FormLabelContainer>
      </ModalContent>
    </Modal>
  );
};
